import { render, staticRenderFns } from "./HomeLive.vue?vue&type=template&id=2a46776f&"
import script from "./HomeLive.vue?vue&type=script&lang=js&"
export * from "./HomeLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports